import React from 'react';

interface MarkProps {
  size?: number;
  className?: string;
}

// Site emblem (emblem-30): a filled-bout cello body with a bass-clef scroll head
// and three thick strings. Reads from ~20px (favicon/nav/footer) up to the hero
// watermark. Uses currentColor so it inherits the surrounding text color/theme.
export function Mark({ size = 28, className }: MarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {/* bass-clef scroll head + clef dots */}
      <path d="M22 18 C22 12 28 9 33 11 C39 13 39 20 34 26" />
      <circle cx="25" cy="15" r="2.6" fill="currentColor" stroke="none" />
      <circle cx="42" cy="15" r="1.8" fill="currentColor" stroke="none" />
      <circle cx="42" cy="22" r="1.8" fill="currentColor" stroke="none" />
      {/* cello body (figure-8), softly filled */}
      <path
        d="M32 26 C38 26 42 30 42 34.5 C42 36.5 40.5 38 38.8 38.8 C44 40.5 46.5 46 44.5 51 C42.5 56 37.5 59 32 59 C26.5 59 21.5 56 19.5 51 C17.5 46 20 40.5 25.2 38.8 C23.5 38 22 36.5 22 34.5 C22 30 26 26 32 26 Z"
        fill="currentColor"
        fillOpacity={0.14}
      />
      {/* thick strings */}
      <path d="M29.5 28 L29.5 57" strokeWidth={1.3} opacity={0.55} />
      <path d="M32 28 L32 57" strokeWidth={1.3} opacity={0.55} />
      <path d="M34.5 28 L34.5 57" strokeWidth={1.3} opacity={0.55} />
    </svg>
  );
}
